import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-questpaper',
  templateUrl: './questpaper.component.html',
  styleUrls: ['./questpaper.component.scss'],
  providers:[MasterService]
})
export class QuestpaperComponent implements OnInit {


  arrqseg:any=[];
  arrqcat:any=[];
  arrqbank:any=[];
  arranstype:any=[];
  arrevlmanswer:any=[];
  objqbank:any={};
  objans:any={};
  selpub:any={};
  arrstatus=[{name:'YES'},{name:'NO'}];
  oprtype='';
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  fileToUpload: File = null;
  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {
    
    // this.sel_evlmqbank('select',1);
    // this.sel_evlmanstype();
    // this.sel_evlmqcategory();
    this.sel_evlmqpaperh();
  }



  sel_evlmanstype() {
    this.mservice.sel_evlmanstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arranstype = resultArray;
            //this.objqbank.anstypeid=resultArray[0].anstypeid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }


  sel_evlmqcategory() {
    this.mservice.sel_evlmqcategory()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrqcat = resultArray;
            //this.objqbank.qucatid=resultArray[0].qucatid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }

  sel_evlmqpaperh() {
    this.mservice.sel_evlmqpaperh()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrqseg = resultArray;
           // this.objqbank.qusegid=resultArray[0].qusegid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }




  sel_evlmanswer(quid) {
    debugger;
    this.mservice.sel_evlmqpaperd(quid)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevlmanswer = resultArray;

            if(resultArray != undefined)
            {
            this.arrevlmanswer.map(function(entry) {
              entry.selected = false;
             
              return entry;
          });
        }
          this.sel_evlmqbank(quid);
            // this.objqbank.qusegid=resultArray[0].qusegid;
            //this.SelectClsSubDetails();
        },
        error => console.log("Error :: " + error)
        )
  }


  openans(content,obj) {
    debugger
    this.sel_evlmanswer(obj.qupid);
    // this.sel_evlmanswer(obj.quid);
      this.objans={};
      // this.objans.rid='0';
      this.objans.qupid=obj.qupid;
      // this.objans.ansdis='';
      // this.objans.score='0';
      this.objans.inid=localStorage.getItem('masclid');
      this.objans.usid=localStorage.getItem('usid');
      this.objans.oprtype='insert';

     
      
     
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'lg'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }
    
  openasses(content,objdata,cmd) {
    debugger
    this.oprtype=cmd;
    if(cmd=='insert')
    {
      this.objqbank={};
     
      
      
      this.objqbank.qupid='0';
      this.objqbank.quptitle='';
      this.objqbank.qupduration='0';
      this.objqbank.qupmaxsc='0';
      this.objqbank.qupdis='';
      this.objqbank.show_result='NO';
      this.objqbank.oprtype='insert';
     
    }
  
    else if(cmd=='update')
    {
      
      this.objqbank=objdata;
      this.objqbank.oprtype='update';
    }
    
    this.modalOptions = {
      backdrop:'static',
      backdropClass:'customBackdrop',
      size:'md'
     
    }
    this.modalRef=this.modalService.open(content,this.modalOptions);
    
    this.modalRef.result.then((result) => {
   
         
      }, (reason) => {
          
      });
  }


  upload(files: FileList) {
    debugger;
    console.log(files);

    if (files[0].type=="image/jpeg"|| files[0].type=="image/jpg" || files[0].type=="image/png")
    {

    this.fileToUpload = files.item(0);
    }
    else{

      alert('Please upload valid image.');
    }
  
   // this.fData.append("bkid", this.memid.toString());
    //this.fData.append("docpurpose", "Studentphoto");
  
    // this.SService.uploadFile(fData).subscribe(
    //     response => this.handleResponse(response),
    //     error => this.handleError(error)
    // )
  }

  saveastype()
{
 console.log('saveobj',this.objqbank);
this.mservice.save_evlmqpaperh(this.objqbank)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            let localmodref=this.modalRef;
            localmodref.close();
          //  this.masasstype();
          this.sel_evlmqpaperh();
          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )

}

deletepaper(obj)
{
  if(confirm("Are you sure ? you want to delete."))
  {

    this.objqbank=obj;
    this.objqbank.oprtype="delete";

    this.saveastype();
  }

}

deletepaperd(obj)
{
  debugger;
  if(confirm("Are you sure ? you want to delete."))
  {

    this.objans=obj;
    this.objans.oprtype="delete";

    this.saveevlmans("del");
  }

}
editevlans(obj)
{
  this.objans={};
  this.objans=obj;

  this.objans.inid=localStorage.getItem('masclid');
  this.objans.usid=localStorage.getItem('usid');
  this.objans.oprtype='update';
  
}

changeevnt(evnt)
{
  debugger
}
saveevlmans(tag)
{
  debugger
  var selbooks;
  if (tag=="add")
  {

     selbooks= this.arrqbank.filter(function(arr)
    {

      return arr.selected==true;
      
    })
  this.objans.loopdata=selbooks;
  this.objans.oprtype="insert";
  }

  else if (tag=="delete")
  {

     selbooks= this.arrevlmanswer.filter(function(arr)
    {

      return arr.selected==true;
    })
  this.objans.loopdata=selbooks;
  this.objans.oprtype="delete";
  }
 var selength=selbooks.length;
 if (selength == 0)
 {
  alert("Please select questions to "+tag);
 }
 else{

  console.log("log",this.objans);
 
  this.mservice.save_evlmqpaperd(this.objans)
      .subscribe(
      result => {
          console.log('SavegenmasDetails', result);
          //this.suppliers = resultArray;
          alert(result.message);
          if(result.status=='success')
          {
            

          this.selpub={};
         
           this.sel_evlmanswer(this.objans.qupid);
          }
         else
         {

         }
      },
      error =>{ alert('Error While saving...');}
      )
    }
}


onpubChangeSearch(sertxt) {
  debugger
  // fetch remote data from here
  // And reassign the 'data' which is binded to 'data' property.
  if(sertxt.query.length>=3) 
  {
    // this.sel_evlmqbank('serch',sertxt.query);
  }
}


sel_evlmqbank(tag) {
  this.mservice.sel_evlmquestions(tag)
      .subscribe(
      resultArray => {
          console.log('getdashcounts', resultArray);
          this.arrqbank = resultArray;

          this.arrqbank.map(function(entry) {
            entry.selected = false;
            entry.rid=0;
            return entry;
        });
          // this.objqbank.qusegid=resultArray[0].qusegid;
          //this.SelectClsSubDetails();
      },
      error => console.log("Error :: " + error)
      )
}


onpubselectEvent(item) {
  //alert('hi');
      console.log('item',item);
      //this.selmember=item;
      //this.getissuedbookinfocnts(item.id);
    //  this.getissueddetails();
      // do something with selected item
    }


}

